<template>
  <div id="design">
    <div class="banner" id="a1">
     <BannerDetail src="https://website.obs.icheer.cn/icheer-web/images/design/banner.jpg"/>
     <div class="mask"></div>
    </div>
    <div class="main">
      <div class="normal">
        <div class="introduction" id="a2">
          <div class="title">以色工业设计，更懂电子产品的工业设计专家</div>
          <div class="content">
            <div class="left">
              <img src="https://website.obs.icheer.cn/icheer-web/images/design/eser.jpg"/>
            </div>
            <div class="right">
              <div class="div1">
                以色工业设计和艾奇科技一样，也是易客创新旗下的核心企业，拥有ID/MD/平面/视频等专业设计师百余名，致力于为广大中小企业提供专业的电子产品工业设计服务。
              </div>
              <div class="div2">
                以色依托易客创新强大的智能电子产品软硬件工程师团队，为客户提供从外观创意设计、结构工程设计到电子方案设计的一站式电子产品原创设计服务，以及产品市场调研、结构堆叠规划、结构优化评审、电子方案评估、跟模及量产技术支持、专利评估报告、平面和视频宣传制作等各种配套增值服务。
              </div>
            </div>
          </div>
        </div>
        <div class="case">
          <div class="title">工业设计部分案例</div>
          <div class="content">
            <div class="item" v-for="item in eserLst" :key="item" :style="{ backgroundImage: 'url(' + item.imgUrl + ')' }">
              <div class="text">
                <span class="title">{{ item.title }}</span>
                <span class="description">{{ item.desc }}</span>
              </div>
              <div class="bg"/>
            </div>
            <div class="more-case" id="a3">
              <a href="https://www.eser.com.cn/html/web/case/index.html" target="_blank">更多详情请访问以色官网</a>
            </div>
            <BrandLogoBarnerFooter  style="padding: 5px;"/>
          </div>

        </div>
<!--        <div class="more-case" id="a3">-->
<!--          <a href="https://www.eser.com.cn/html/web/case/index.html" target="_blank">更多详情请访问以色官网</a>-->
<!--        </div>-->

      </div>
    </div>
  </div>
</template>
<script setup>
import { watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import BannerDetail from './BannerDetail.vue'
import ImageTextLine from '@/components/ImageTextLine.vue'
import BrandLogoBarnerFooter from '@/components/BrandLogoBarnerFooter.vue'
const $router = useRouter()

const eserLst = [
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/lengfengji.jpg',
    title: '冷风机',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/chushiji.png',
    title: '除湿机',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/jiatingyinxiang.png',
    title: '家庭音箱',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/jingbuanmoyi.png',
    title: '颈部按摩仪',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/tuomaoyi.png',
    title: '脱毛仪',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/changpianji.png',
    title: '唱片机',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/erheyiwuxianchong.png',
    title: '二合一无线充',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/dianrefanhe.png',
    title: '电热饭盒',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/fangtangzhinengyinxiang.jpg',
    title: '方糖智能音箱',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/wurenji.png',
    title: '无人机',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/huaweileqizhinengdiandongche.jpg',
    title: '华为乐骑智能电动车',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/xiaoduwangui.jpg',
    title: '消毒碗柜',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/guabofengshan.png',
    title: '挂脖风扇',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/kongqijinghuaqi.png',
    title: '空气净化器',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/kongqizhaguo.png',
    title: '空气炸锅',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/miewendeng.jpg',
    title: '灭蚊灯',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/zhuomianxiaofengshan.jpg',
    title: '桌面小风扇',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/maikefeng.png',
    title: 'K歌麦克风',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/chunengdianyuan.jpg',
    title: '储能电源',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/diandongyashua.png',
    title: '电动牙刷',
    desc: '结构设计 / 外观设计'
  },
  {
    imgUrl: 'https://website.obs.icheer.cn/icheer-web/images/design/case/dianfangou.png',
    title: '电饭锅',
    desc: '结构设计 / 外观设计'
  }
]

onMounted(() => {
  watch(() => $router.currentRoute.value.query, (newValue, oldValue) => {
    const arch = $router.currentRoute.value.query.arch
    if (arch == null) return
    const target = document.querySelector(`#${arch}`)
    target.scrollIntoView({
      behavior: 'smooth'
    })
  }, { immediate: true })
})
</script>
<style>
#design>.banner, #design {
  width: 100%;
  height: auto;
  min-width: 375px;
}

#design>.banner{
  margin: 0 auto;
}

#design>.banner>.mask{
  height: 10.42vw;
  width: 100%;
  position: absolute;
  top: 0;
  background-image: linear-gradient(rgba(80, 80, 80, 0.7), rgba(80, 80, 80, 0.3), rgba(80, 80, 80, 0));
}

#design>.main>.normal, #design>.main {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#design>.main{
  min-width: 375px;
  margin: 0 auto;
  padding-top: 3.49vw;
  justify-content: center;
}

#design>.main>.normal>.more-case a {
  text-decoration: none;
  font-size: 0.95vw;
  color: #0253d9;
  margin-bottom: 30px;
}

#design>.main>.normal>.introduction {
  width: 62.5vw;
  height: auto;
  margin-bottom: 3.5vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#design>.main>.normal>.introduction>.title {
  font-size: 1.563vw;
  font-weight: 700;
  margin-bottom: 1.95vw
}

#design>.main>.normal>.introduction>.content {
  width: 100%;
  height: 20.85vw;
  display: flex;
  flex-direction: row;
  background-color: #f5f5f5;
  border-radius: 0.5vw
}

#design>.main>.normal>.introduction>.content>.left {
  width: 53.5vw;
  height: 100%;
  object-fit: cover
}

#design>.main>.normal>.introduction>.content>.left img{
  width: 100%;
  max-height: 100%;
  border-radius: 0.5vw;
  object-fit: cover
}

#design>.main>.normal>.introduction>.content>.right{
  width: 46.5vw;
  height: 100%;
  padding-top: 2.25vw;
  padding-left: 2vw;
  padding-right: 2vw
}

#design>.main>.normal>.introduction>.content>.right>.div1 {
  font-size: .88vw;
  line-height: 1.83vw;
  letter-spacing: 0.025vw;
  margin-bottom: 1.7vw
}

#design>.main>.normal>.introduction>.content>.right>.div2 {
  font-size: 0.88vw;
  line-height: 1.83vw;
  letter-spacing: 0.025vw
}

#design>.main>.normal>.case {
  width: 100%;
  margin: 0 auto 1vw auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center
}

#design>.main>.normal>.case>.title{
  font-size: 1.563vw;
  font-weight: 700;
  margin-bottom: 1.95vw;
  text-align: center
}

#design>.main>.normal>.case>.content {
  width: 64vw;
  padding: 0 0 0 0.5vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: center
}

#design>.main>.normal>.case>.content>.item {
  height: 11.75vw;
  width: 20.5vw;
  margin: 0 0.5vw 0.5vw 0;
  border-radius: 0.52vw;
  position: relative;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 105%;
  transition: background-size 0.5s;
  display: flex;
  justify-content: center
}

#design>.main>.normal>.case>.content .item:focus,#design>.main>.normal>.case>.content .item:hover {
  background-size: 160%
}

#design>.main>.normal>.case>.content .item .text {
  z-index: 2;
  cursor: pointer;
  text-decoration: none;
  padding-top: 10.5vw;
  display: none;
  text-align: center;
  flex-direction: column;
  justify-content: center
}

#design>.main>.normal>.case>.content .item:focus .text,#design>.main>.normal>.case>.content .item:hover .text{
  display: flex
}

#design>.main>.normal>.case>.content .item .text .title{
  font-size: 1.47vw;
  font-weight: 700;
  color: #fcfefd;
  margin-bottom: 0.5vw;
  display: block;
  text-align: center
}

#design>.main>.normal>.case>.content .item .text .description{
  margin: 0 0 10vw 0;
  font-size: 1vw;
  color: #fcfefd;
  display: block;
  text-align: center
}

#design>.main>.normal>.case>.content .item .text-hover {
  opacity: 0.9;
  display: none
}

#design>.main>.normal>.case>.content .item:focus .text-hover,#design>.main>.normal>.case>.content .item:hover .text-hover{
  width: 100%;
  margin: 0 0 0 0;
  font-size: 1.35vw;
  z-index: 4;
  color: #fff;
  display: block;
  text-align: center
}

#design>.main>.normal>.case>.content .item .bg{
  border-radius: 0.52vw;
  display: none
}

#design>.main>.normal>.case>.content .item:focus .bg,#design>.main>.normal>.case>.content .item:hover .bg{
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.8;
  background-color: #0470fd;
  position: absolute;
  left: 0;
  top: 0;
  display: block
}
</style>
